import { Trans, useTranslation } from "react-i18next";

import type { IConsumableInventoryEntry } from "@/types/(company)/assets.interface";

/** Renders a consumable inventory entry breakdown (unit type + quantity + stock left). */
export const InventoryColumn = ({
  inventory,
  field,
}: {
  inventory: IConsumableInventoryEntry[] | null;
  field: "unitCount" | "stockUnitsLeft" | "issuedUnits";
}) => {
  const { t } = useTranslation(["assets"]);
  return (
    <div className="flex flex-col gap-1">
      {inventory
        ? inventory.map((item) => (
            <div key={item.id} className="flex items-center gap-3 text-sm">
              <span className="text-gray-500 w-14">{item.unitType.name}</span>
              <span className="font-medium tabular-nums">
                {String(item[field]).padStart(2, "0")}
              </span>
              <p className="text-[11px] text-gray-400">
                <Trans
                  t={t}
                  i18nKey="assets:stock_left_parenthesized"
                  values={{
                    value: String(item.stockUnitsLeft).padStart(2, "0"),
                  }}
                  components={{
                    1: <span className="font-semibold text-gray-600" />,
                  }}
                />
              </p>
            </div>
          ))
        : "-"}
    </div>
  );
};
